import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M22.6 17.6c-5.288 0-9.637 3.925-10.387 8.944A8.378 8.378 0 0010.2 26.3 8.17 8.17 0 002 34.5v25.9a8.17 8.17 0 008.2 8.2c.675 0 1.353-.08 2.01-.243A10.453 10.453 0 0022.6 77.3c5.745 0 10.5-4.64 10.5-10.5v-8.7h23.5v8.7c0 5.745 4.64 10.5 10.5 10.5 5.288 0 9.637-3.925 10.387-8.944a8.378 8.378 0 002.013.244 8.17 8.17 0 008.2-8.2V34.5c0-4.47-3.766-8.1-8.2-8.1-.675 0-1.353.08-2.01.243A10.453 10.453 0 0067.1 17.7c-5.745 0-10.5 4.64-10.5 10.5V38H33.1v-9.9c0-5.745-4.64-10.5-10.5-10.5zm-4.2 10.5c0-2.348 1.852-4.2 4.2-4.2s4.2 1.852 4.2 4.2v38.7c0 2.348-1.852 4.2-4.2 4.2a4.165 4.165 0 01-4.2-4.2V28.1zm44.5 0c0-2.348 1.852-4.2 4.2-4.2s4.2 1.852 4.2 4.2v38.7c0 2.348-1.852 4.2-4.2 4.2a4.165 4.165 0 01-4.2-4.2V28.1zM8.3 34.5c0-1.048.852-1.9 1.9-1.9s1.9.852 1.9 1.9v25.9c0 1.048-.852 1.9-1.9 1.9s-1.9-.852-1.9-1.9V34.5zm69.3 0c0-1.048.852-1.9 1.9-1.9s1.9.852 1.9 1.9v25.9c0 1.048-.852 1.9-1.9 1.9s-1.9-.852-1.9-1.9V34.5zm-21 17.4H33.1v-7.7h23.5v7.7z",
      stroke: "none"
    })]
  });
};
const IconWeights = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Weights__IconWeights",
  componentId: "sc-r5fi3c-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconWeights };
